import React, { PropsWithChildren, useRef } from 'react';
import { MDXProvider } from '@mdx-js/react';

function textFromChildren(children: any): string {
  if (typeof children === 'string' || typeof children === 'number') return String(children);
  if (Array.isArray(children)) return children.map(textFromChildren).join('');
  if (children && typeof children === 'object' && 'props' in children) {
    return textFromChildren((children as any).props?.children);
  }
  return '';
}

const META_H2_RE = /^\s*title:\s*.+?\bslug:\s*.+?\border:\s*.+$/i;

export default function WithMDXProvider({ children }: PropsWithChildren) {
  // If you want to nuke ONLY the first <hr /> (from the opening ---), track it:
  const seenFirstHr = useRef(false);

  const components = {
    h1: (props: any) => <h1 style={{ marginTop: 0, display: 'none' }} {...props} />,
    pre: (props: any) => <pre style={{ overflow: 'auto' }} {...props} />,

    // Hide the metadata H2 block that MDX produced from the YAML lines
    h2: (props: any) => {
      const txt = textFromChildren(props.children);
      if (META_H2_RE.test(txt)) return null; // skip rendering
      return null;
    },

    // Option A: remove only the very first <hr /> (from the initial ---)
    hr: (props: any) => {
      if (!seenFirstHr.current) {
        seenFirstHr.current = true;
        return null; // drop the first one
      }
      return <hr {...props} />;
    },

    // If you *never* use <hr> in docs, you can instead do:
    // hr: () => null,
  };

  return <MDXProvider components={components}>{children}</MDXProvider>;
}
